export default __webpack_public_path__ + "static/media/1229.e79316a7.JPG";